import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-delete-confirmation',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule
],
  templateUrl: './delete-confirmation.html',
  styleUrl: './delete-confirmation.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteConfirmationComponent {
  @Input() visible = false;
  @Input() title = $localize`:@@deleteConfirm.defaultTitle:Confirm Deletion`;
  @Input() subtitle = $localize`:@@deleteConfirm.defaultSubtitle:Are you sure you want to delete this item? This action cannot be undone.`;
  @Input() deleting = false;

  readonly deleteLabel = $localize`:@@common.delete:Delete`;
  readonly deletingLabel = $localize`:@@deleteConfirm.deleting:Deleting...`;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onCancel(): void {
    if (!this.deleting) {
      this.visible = false;
      this.visibleChange.emit(false);
      this.cancel.emit();
    }
  }

  onConfirm(): void {
    if (!this.deleting) {
      this.confirm.emit();
    }
  }

  onHide(): void {
    if (!this.deleting) {
      this.visible = false;
      this.visibleChange.emit(false);
    }
  }
}
